import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface IIdPropertyEditable {
  id(): IPropertyEditable<number>;
}

export function instanceOfIIdPropertyEditable(instance: any): instance is IIdPropertyEditable {
  return instance
      && instance.id
      && instanceOfIPropertyEditable<number>(instance.id());
}
